// extracted by mini-css-extract-plugin
module.exports = {"BirdImage":"BirdImage_BirdImage__1nssg"};